<div class="result-icon" [ngClass]="resultClass">
    <app-icon iconName="circle" classes="match"></app-icon>
</div>
<span>{{resultText}}</span>
